/* eslint-disable */

import { snackbar } from '@/_core/app-components/use/useSnackbar';

const boot = (isMobile: boolean) => {
    const options: any = {
        app_id: initAppData.trackingTools.intercomAppId,
    };

    if (initAppData.currentUser != null) {
        options.name = initAppData.currentUser.currentUserFullName;
        options.email = initAppData.currentUser.currentUserLoginName;
        options.user_id = initAppData.currentUser.currentUserId;
        options.created_at = initAppData.currentUser.currentUserSignUpDateUnixTimestamp;

        if (initAppData.isInWsContext) {
            options.company = {
                id: initAppData.currentWs.workspaceId,
            };
        }
    }
    callIntercom('boot', options);

    if(isMobile){
        setTimeout(() => {
            callIntercom('update', {
                "hide_default_launcher": true
            });
        });     
    }
};

const update = () => {
    callIntercom('update');
};

const showMessage = (msg: string = '') => {
    callIntercom('showNewMessage', msg);
};

const callIntercom = (cmd: 'showNewMessage' | 'boot' | 'update', ...args: any[]) => {
    if ((<any>window).Intercom) {
        //@ts-ignore
        Intercom(cmd, ...args);
    } else {
        snackbar.showError('The intercom feature is disabled.');
    }
};

const intercomService = {
    boot,
    update,
    showMessage,
};

export default intercomService;
